<div class="title-bar baseline">
  <h1>
    {{ "PRODUCTS.IMPORT.TITLE.HEADER" | translate }}
  </h1>
</div>
<!-- <mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  animationDuration="0ms"
>
  <mat-tab label="{{ 'PRODUCTS.IMPORT.IMAGES.TAB.TITLE' | translate }}">
    <app-product-import-images class="mt-5"></app-product-import-images>
  </mat-tab>
  <mat-tab label="{{ 'PRODUCTS.IMPORT.TABLE_CHECKER.TAB.TITLE' | translate }}">
    <app-product-import-table-checker
      class="mt-5"
    ></app-product-import-table-checker>
  </mat-tab>
</mat-tab-group> -->

<nav mat-tab-nav-bar class="easy-tab mb-5" [tabPanel]="tabPanel">
  <a
    mat-tab-link
    [routerLink]="'/selling/product-import/images'"
    [active]="activeLinkIndex === 0"
  >
    {{ "PRODUCTS.IMPORT.IMAGES.TAB.TITLE" | translate }}
  </a>
  <a
    *ngIf="devMode"
    mat-tab-link
    [routerLink]="'/selling/product-import/table-checker'"
    [active]="activeLinkIndex === 1"
  >
    {{ "PRODUCTS.IMPORT.TABLE_CHECKER.TAB.TITLE" | translate }}
  </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
